<template>
  <div class="verval">
    <v-card flat>
      <v-card-text>
        <h4 class="black--text">Daftar Sertifikat</h4>
        <v-divider class="my-2" />
        <base-table-header @reload="onReload">
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              Jumlah Data <span class="blue--text font-weight-medium">{{ total }}</span>
            </div>
          </template>
        </base-table-header>
        <v-divider />
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row no-gutters>
                    <v-col cols="12" md="6">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="blue">
                          <v-icon dark>mdi-certificate-outline</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 px-1">
                          <div class="body-1">{{ $getDeepObj(item, 'm_sertifikat.data.judul') || '-' }} </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <div class="label--text">
                            Peran
                          </div>
                          <div class="body-2">
                            {{ $getDeepObj(item, 'peran') }}
                            <!--                            <span>-->
                            <!--                              (Angkatan-->
                            <!--                              {{ $getDeepObj(item, 'angkatan') || $getDeepObj(item, 'data.angkatan') || 1 }})-->
                            <!--                            </span>-->
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                      <v-col cols="12" md="2"> </v-col>
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <div class="label--text">
                            Aksi Selanjutnya
                          </div>
                          <div class="mt-1">
                            <v-btn depressed color="primary" small @click="onDownloadSertifikat(item)">
                              <v-icon left>mdi-download</v-icon> Unduh Sertifikat
                            </v-btn>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import list from '@mixins/list';
import actions from './action';
export default {
  mixins: [list],
  data() {
    return {
      actions: actions,
    };
  },
  computed: {},
  methods: {
    ...mapActions('sertifikat', {
      fetch: 'fetch',
      download: 'download',
    }),

    onDownloadSertifikat(item) {
      this.download({ id: item.id }).then((url) => {
        window.open(url, '_blank');
      });
    },
  },
};
</script>
